/* global window */
/* eslint-disable strict */

window.PatternLibrary = window.PatternLibrary || {};

(function(behaviors) {
    'use strict';

    behaviors.detectTouch = {
        properties: {

            /**
             * Whether the user's device is touch-screen
             */
            touch: {
                reflectToAttribute: true,
                type: Boolean,
                value() {
                    return this._isTouch();
                }
            }
        },

        /**
         * Returns whether the browser is on touch device
         *
         * @return {Boolean}
         */
        _isTouch() {
            const parentCheck = this.parentNode
                ? this.parentNode.touch
                : undefined; // eslint-disable-line no-undefined

            if (typeof parentCheck !== 'undefined') {
                return parentCheck;
            }

            return (
                !this._isWindows10PC()
                && ('ontouchstart' in window
                || window.navigator.maxTouchPoints > 0
                || window.navigator.msMaxTouchPoints > 0)
            );
        },

        /**
         * Returns whether the browser is on Windows 10 PC
         *
         * @returns {Boolean}
         */
        _isWindows10PC() {
            const userAgent = window.navigator.userAgent;

            return (
                /(Windows NT 6\.4|Windows NT 10\.\d)/.test(userAgent)
                && !(/Touch/.test(userAgent))
            );
        }
    };
})(
    window.PatternLibrary.behaviors = window.PatternLibrary.behaviors || {}
);
